import {createFileRoute} from '@tanstack/react-router'
import Master_VenuesView from "../../../master/VenuesView.tsx";

export const Route = createFileRoute('/_app/master/venues')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Master_VenuesView />
}
